export default {
  'api_manager': 'API Management',
  'api_my_key': 'My API Key',
  'api_del_sure': 'Are you sure you want to remove this API Key?',
  'api_tip_0': 'Creating an API private key provides access to markets and real-time trading services on Biconomy via a third-party site or application. Please set {dom} before creating API.',
  'api_tip_1': 'You can use the API market query, automatic trading and other services. See how to use it through the API documentation.',
  'api_tip_2': 'Each account can create up to {num} API Keys.',
  'api_tip_3': 'Do not disclose your API Key to anyone to avoid asset losses. It is recommended to bind IP for API Key to increase your account security.',
  'api_tip_4': 'Be aware that your API Key may be disclosed by authorizing it to a third-party platform.',
  'api_tip_5': 'Please complete KYC before creating API.',
  'api_tip_6': 'For security reasons, it is recommended to bind IP for API Key, and each API Key can be bound to up to {num} IPs. Fill in a single address directly, multiple IP addresses half Angle commas, such as 192.168.1.1, 192.168.1.2, 192.168.1.3.',
  'api_create': 'Create API Key',
  'api_create_placeholder': 'Label API Key to proceed',
  'api_view': 'View API documentation',
  'api_key': 'API Key',
  'secret_key': 'Secret Key',
  'api_ip_access': 'IP Access Restriction',
  'api_ip_check1': 'Unrestricted (Less Secure)  This API key allows access from any IP address. This is not recommended.',
  'api_ip_check2': 'Restrict access to trusted IPs only (Recommended)',
  'api_ip_placeholder': 'When entering more than one IP address, please separate them with spaces.',

  'ip_address_enter': 'Please enter IP address',
  'ip_address_invalid': 'The format of the IP address is incorrect',

  'api_more_tip': 'Up to {IP} IP addresses can be bound',
  'api_more_ip_tip': 'Up to {IP} apis can be bound',
  'api_create_success': 'Creating a successful',
  'label_enter': 'Please enter label',
  'api_label_wrong': 'The label should be within 1-20 characters',
}